import {updateCampaignStepCloud} from '../../../../../utility/api/campaign/updateCampaignStepCloud';
import {formatErrorResponse} from '../../../../../utility/api/formatErrorResponse';
import {uploadDataToAws} from '../../../../../utility/api/campaign/uploadDataToAws.js';

import swal from 'sweetalert2';

export const builderMixin = {
  methods: {
    onSetStatus(status) {
      this.enabled = status;
      this.unsaved = true;
    },
    setStepStatusInTimeline(data) {
      const {status, id} = data;
      const panel = document.getElementById('timeline-panel' + id);
      if (panel) panel.setAttribute('data-status', status);
    },
    async updateStep(step) {
      try {
        const path = await uploadDataToAws(step);
        await updateCampaignStepCloud(this.campaign.id, {path, id: step.id});
        $.notify('Saved!', 'success');
        this.setStepStatusInTimeline(step);
      } catch (error) {
        const text =
          error.response && error.response.data
            ? formatErrorResponse(error.response.data)
            : 'There was an error saving the step.';
        swal.fire({
          title: 'UhOh!',
          text,
          type: 'error',
          confirmButtonText: 'Ok',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-lg btn-primary',
        });
      }
    },
  },
  created() {
    this.enabled = this.stepStatus;
  },
};
